import * as m from "mithril";
import { ApiService } from "./ApiService";


export interface IApiProvider {
    getApiService(): Promise<ApiService>;
}


export class ApiProvider implements IApiProvider {
    apiService: ApiService | null;

    setApiService(apiService: ApiService) {
        this.apiService = apiService;
    }

    async waitForApiSeviceReady(maxRetries = 200): Promise<boolean> { // 300* 200 => 60000 ( 60seconds, 1min) 
        const checkReady = async (): Promise<boolean> => {
            return this.apiService != null;
        };

        let attempts = 0;
        let isReady = false;

        while (!(isReady = await checkReady())) {
            attempts++;
            if (attempts >= maxRetries) {
                throw new Error("Api Service Initialization Timeout!");
            }

            await new Promise(resolve => setTimeout(resolve, 300));
        }

        return isReady;

    }
    
    async getApiService(): Promise<ApiService> {
        await this.waitForApiSeviceReady();
        return this.apiService!;
    }
}